import { atom } from 'recoil';

export const isCartModalOpenState = atom<boolean>({
	key: 'isCartModalOpen',
	default: false
});
